import React, { useState } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import {
  Tabs,
} from 'antd';
import {
  myLeadsHeaderAtom,
} from '../../../../../atoms/Atoms';
import {
  thousand,
} from '../../../../../functions';
import LeadsSearchTable from './LeadsSearchTable';

function LeadsClosed({ className, orgReferral, useGlobal, isSetter }) {
  const { t } = useTranslation();
  const myLeadsHeader = useRecoilValue(myLeadsHeaderAtom);
  const { TabPane } = Tabs;
  const [selectedTab, setSlectedTab] = useState('installed');

  return (
    <div className={className}>
      <Tabs activeKey={selectedTab} onChange={(tab) => setSlectedTab(tab)}>
        <TabPane key="installed" tab={`${t('installed')} (${thousand(myLeadsHeader?.totalInstalled)})`}>
          {selectedTab === 'installed' && (
            <LeadsSearchTable orgReferral={orgReferral} useGlobal={useGlobal} isSetter={isSetter} searchType={5} />
          )}
        </TabPane>
        <TabPane key="activated" tab={`${t('activated')} (${thousand(myLeadsHeader?.totalActivated)})`}>
          {selectedTab === 'activated' && (
            <LeadsSearchTable orgReferral={orgReferral} useGlobal={useGlobal} isSetter={isSetter} searchType={6} />
          )}
        </TabPane>
      </Tabs>
    </div>
  );
}

export default LeadsClosed;
